import { useEffect, useState } from "react"
import axios from "config/axios"
import cookie from 'react-cookies'

const useHotCommunities = (page: number, pageSize = 8) => {
  const [data, setData] = useState<any>({list: [], total: 0})
  const [loading, setLoading] = useState(false)
  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await axios.get(`/api/admin/stats/hot/community?page=${page}&pagesize=${pageSize}`)
      const max = res.data.data.data[0]?.social_volume
      if (page === 1) cookie.save('soad_max', max, { path: '/' })
      setLoading(false)
      setData({list: res.data.data.data, total: res.data.data.total})
    } catch (error) {
      console.error("useHotCommunities --> " + error)
    }
  }
  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [page])
  return [data, loading]
}

export default useHotCommunities
